var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isCookieBannerVisible ? _c('div', {
    staticClass: "cookie-banner"
  }, [_c('div', {
    staticClass: "cookie-banner-inner"
  }, [_c('p', {
    staticClass: "cookie-banner-description"
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.message")) + " "), _c('button', {
    staticClass: "p-0 btn btn-link",
    on: {
      "click": _vm.onCustomSettingsClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.customize_selection")) + " ")])]), _c('div', {
    staticClass: "cookie-banner-info"
  }), _c('div', {
    staticClass: "cookie-banner-actions"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function ($event) {
        return _vm.onNecessaryOnlyClick();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.only_necessary")) + " ")]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function ($event) {
        return _vm.onAcceptAllClick();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.accept_all")) + " ")])])]), _vm.isAdvancedView ? _c('Modal', {
    attrs: {
      "title": _vm.$t('cookie_consent.header'),
      "close-on-mask-click": false
    },
    on: {
      "close": _vm.closeBanner
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('CookieSelector', {
          model: {
            value: _vm.config,
            callback: function ($$v) {
              _vm.config = $$v;
            },
            expression: "config"
          }
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-secondary",
          on: {
            "click": _vm.onSaveClick
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.confirm_selection")) + " ")]), _c('button', {
          staticClass: "btn btn-sm btn-primary",
          on: {
            "click": _vm.onAcceptAllClick
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("cookie_consent.accept_all")) + " ")])])];
      },
      proxy: true
    }], null, false, 2124411776)
  }) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }